export default __webpack_public_path__ + "static/media/soesvinget-property-05.900ca558.jpg";